module.exports = __webpack_public_path__ + "static/img/医生直播@2x2.a5dd67d1.png";